/**
 * Relative-time presentation helper (J6, Wave 3).
 *
 * The refusal panel renders "2h ago" / "1d ago" per the confirmed mock from
 * the server-provided ISO `at` timestamp. Pure formatting only — no verdicts.
 */

/**
 * "just now" / "5m ago" / "2h ago" / "1d ago"; falls back to a locale date
 * beyond 30 days and returns the raw input when it does not parse (honest —
 * never invents a time).
 */
export function formatRelativeTime(iso: string, now: Date = new Date()): string {
  const then = new Date(iso);
  if (Number.isNaN(then.getTime())) return iso;
  const diffMs = now.getTime() - then.getTime();
  const minutes = Math.floor(diffMs / 60_000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days <= 30) return `${days}d ago`;
  return then.toLocaleDateString();
}
